import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const BrokersListPage = lazy(() =>
  import('./pages/BrokersListPage').then((m) => ({ default: m.BrokersListPage })),
);

export const brokerRoutes: RouteObject[] = [{ path: '/brokers', element: <BrokersListPage /> }];
